export let filterOptionsArray = [
    { id: "today", name: "Today", initialValueCalc: 0, endValueCalc:0 },
    { id: "1DaysAgo", name: "Yesterday", initialValueCalc: -1, endValueCalc:-1 },
    { id: "2DaysAgo", name: "2 days ago", initialValueCalc: -2, endValueCalc:-2 },
    { id: "3DaysAgo", name: "3 days ago", initialValueCalc: -3, endValueCalc:-3 },
    { id: "Last7Days", name: "Last 7 days", initialValueCalc: -7, endValueCalc:-1 },
    { id: "Last14Days", name: "Last 14 days", initialValueCalc: -14, endValueCalc:-1 },
    { id: "Last30Days", name: "Last 30 days", initialValueCalc: -30, endValueCalc:-1 },
    { id: "Last60Days", name: "Last 60 days", initialValueCalc: -60, endValueCalc:-1 },
    { id: "Last90Days", name: "Last 90 days", initialValueCalc: -90, endValueCalc:-1 },
    { id: "LastMonth", name: "Last Month" },
    { id: "ThisMonth", name: "This Month" }
  ];
  